import "@fontsource/montserrat";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./NewDesign/reportWebVitals";
import "./index.css";

import "bootstrap/dist/css/bootstrap.min.css";

import { createBrowserRouter, RouterProvider, Route } from "react-router-dom";
import ReactGA from "react-ga";
import { GoogleOAuthProvider } from '@react-oauth/google';

import Landing from "./NewDesign/Components/Landing/Landing";
import ExamRecommendationRoute from "./NewDesign/Components/Exams/ExamRecommendation/ExamRecommendationRoute";
import OrderConfirmedRoute from "./NewDesign/Components/Orders/OrderConfirmed/OrderConfirmedRoute";

import LogContextProvider from "./NewDesign/Components/Context/LoginContext";
import UserInfoProvider from "./NewDesign/Components/Context/UserInfoContext";
import PacksProvider from "./NewDesign/Components/Context/PacksContext";
import MedicalContextProvider from "./NewDesign/Components/Context/MedicalContext";

import ExamChoiceByGenderRoute from "./NewDesign/Components/Exams/ExamChoiceByGender/ExamChoiceByGenderRoute";
import ExamChoiceBySponsorRoute from "./NewDesign/Components/Exams/ExamChoiceBySponsor/ExamChoiceBySponsorRoute";
import ExamChoiceByPhysicalSaleRoute from "./NewDesign/Components/Exams/ExamChoiceByPhysicalSale/ExamChoiceByPhysicalSaleRoute";

import ExamsByPacksRoute from "./NewDesign/Components/Exams/ExamsByPacks/ExamsByPacksRoute";
import RemakeOrderRoute from "./NewDesign/Components/Orders/RemakeOrder/RemakeOrderRoute";
import ContactRoute from "./NewDesign/Components/FAQ/ContactRoute";
import WeAreYMCRoute from "./NewDesign/Components/WeAreYMC/WeAreYMCRoute";


const TRACKING_ID = "G-5TSZG25VY0"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const Router = createBrowserRouter([
 
 
  {
    path: "/orden-medica",
    element: (
      <>
      <title>YMC | Orden Médica</title>
      <UserInfoProvider>
      <MedicalContextProvider>
      <PacksProvider>
      <ExamRecommendationRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </UserInfoProvider>
      </>
    ),
  },
  {
    path: "/mi-orden-medica",
    element: (
      <>
      <title>YMC | Mi Orden Médica</title>
      <UserInfoProvider>
      <MedicalContextProvider>
      <OrderConfirmedRoute />
      </MedicalContextProvider>
      </UserInfoProvider>
      </>
    ),
  },
  {
    path: "/",
    element: (
      <>
      <title>Yo Me Controlo</title>
      <UserInfoProvider>
      <MedicalContextProvider>
      <PacksProvider>
      <Landing />
      </PacksProvider>
      </MedicalContextProvider>
      </UserInfoProvider>
      </>
    ),
  },
  
  {
    path: "/detalles-de-pack",
    element: (
      <>
      <title>YMC | Detalles de Pack</title>
      <MedicalContextProvider>
      <PacksProvider>
      <UserInfoProvider>
      <LogContextProvider>
      <ExamChoiceByGenderRoute/>
      </LogContextProvider>
      </UserInfoProvider>
      </PacksProvider>
      </MedicalContextProvider>
      </>
    )
  },
  {
    path: "/pack-patrocinado",
    element: (
      <>
      <title>YMC | Pack Patrocinado</title>
      <MedicalContextProvider>
      <PacksProvider>
      <UserInfoProvider>
      <LogContextProvider>
      <ExamChoiceBySponsorRoute/>
      </LogContextProvider>
      </UserInfoProvider>
      </PacksProvider>
      </MedicalContextProvider>
      </>
    )
  },
  {
    path: "/pack-fisico",
    element: (
      <>
      <title>YMC | Pack Físico</title>
      <MedicalContextProvider>
      <PacksProvider>
      <UserInfoProvider>
      <LogContextProvider>
      <ExamChoiceByPhysicalSaleRoute/>
      </LogContextProvider>
      </UserInfoProvider>
      </PacksProvider>
      </MedicalContextProvider>
      </>
    )
  },
  {
    path: "/packs-de-examenes",
    element: (
      <>
      <title>YMC | Packs de Exámenes</title>
      <MedicalContextProvider>
      <PacksProvider>
      <UserInfoProvider>
      <LogContextProvider>
      <ExamsByPacksRoute />
      </LogContextProvider>
      </UserInfoProvider>
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/recuperar-orden-medica",
    element: (
      <>
      <title>YMC | Recuperar Orden Médica</title>
      <UserInfoProvider>
      <MedicalContextProvider>
      <PacksProvider>
        <RemakeOrderRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </UserInfoProvider>
      </>
    ),
  },
  {
    path:"/quienes-somos",
    element:(
      <>
      <title>YMC | Quiénes Somos</title>
      <MedicalContextProvider>
        <PacksProvider>
          <UserInfoProvider>
            <LogContextProvider>
             <WeAreYMCRoute/>
            </LogContextProvider>
          </UserInfoProvider>
        </PacksProvider>
      </MedicalContextProvider>
      </>
    )
  },
  {
    path: "/contacto",
    element: (
      <>
      <title>YMC | Contacto</title>
      <UserInfoProvider>
      <MedicalContextProvider>
      <PacksProvider>
        <ContactRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </UserInfoProvider>
      </>
    ),
  },
  
  
 
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="373324863794-24umjtie522qdma9b4kro9lg8q7804nj.apps.googleusercontent.com">
<RouterProvider router={Router} />
</GoogleOAuthProvider>
);

const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

reportWebVitals(SendAnalytics);
